import MapBox from "./MapBox"


function SearchSection() {

  return (
    <div className='search-section'>
        <MapBox/>
    </div>
  )
}

export default SearchSection